import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper/Paper'
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {        
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        position: 'relative',
        boxShadow: "0 2px 5px 0 rgba(0,0,0,0.26), 0 2px 10px 0 rgba(0,0,0,0.16)",
        height:'100%'
    },
    containerPadded: {
        padding: "20px 20px",
    },
    containerDanger: {
        borderLeft: '10px solid #DD1E31',
        borderRadius: "2px 0 0 2px",
        backgroundColor: '#FFFFFF',
        position: 'relative',
        margin: "0 0 30px 0",
        padding: "15px",
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'white',
        opacity: 0.7,
        zIndex: 5,
    },
    loadingAnimation: {
        alignSelf: 'center',
    },
    title: {
        fontSize: 22,
        fontWeight: 300,
        color: "rgba(0,0,0,0.7)",
        marginBottom: 10,
    },
    infoTooltip:{
        marginLeft:'10px'
    }
};


const CudaPaper = ({ classes, children, loading = false, tooltip, loadingAnimationSize = 40, disabled, padding = false, containerPaper, title }) => {
    const newClasses = {
        [classes.container]: true,
        [classes.containerPadded]: padding,
    };

    if(containerPaper){
        newClasses[containerPaper] = true;
    }

    const containerClass = classNames(newClasses);

    return (
        <Paper className={containerClass}>
            {loading &&
                <div className={classes.overlay}>
                    <div className={classes.loadingAnimation}>
                        <CircularProgress size={loadingAnimationSize} />
                    </div>
                </div>
            }
            {disabled && <div className={classes.overlay} />}

            {title &&
                <div className={classes.title}>
                    {title}
                    {/* {tooltip &&
                        <span className={classes.infoTooltip}>
                            <MCudaTooltip title={tooltip}>
                                <InfoIcon />
                            </MCudaTooltip>
                        </span>
                    } */}
                </div>
            }

            {children}
        </Paper>
    );
};

export default withStyles(styles, { name: 'CudaPaper' })(CudaPaper);


const _CudaDangerPaper = ({ classes, children }) => {
    return (
        <Paper className={classes.containerDanger}>
            {children}
        </Paper>
    );
};

const CudaDangerPaper = withStyles(styles, { name: 'CudaPaper' })(_CudaDangerPaper);
export { CudaDangerPaper } 